export enum CardType {
    Investigator,
    Location,
    Agenda,
    Act,
    Treachery,
    Enemy,
    Asset,
    Event,
    Skill,
    ScenarioReference
}
export interface IDeckBrowserFilter {
    maxNeutralLevel: number;
    maxGuardianLevel: number;
    maxSeekerLevel: number;
    maxRougeLevel: number;
    maxMysticLevel: number;
    maxSurvivorLevel: number;
    hiddenCards: ICardReference[];
    uniqueCards: string[];
}
export interface IPlayerCard {
    card: ICard;
    amount: number;
    key: string;
}
export interface ICustomDeckBuilderRule {
    modifyFilter(playerCards: IPlayerCard[], filter: IDeckBrowserFilter): void;
}
export class MaxOfOtherCardTypesRule implements ICustomDeckBuilderRule {
    maxNoOfCards: number;
    maxLevel: number;
    types: CardSubType[];
    constructor(maxNoOfCards: number, maxLevel: number, types: CardSubType[]) {
        this.maxNoOfCards = maxNoOfCards;
        this.maxLevel = maxLevel;
        this.types = types;
    }
    modifyFilter(playerCards: IPlayerCard[], filter: IDeckBrowserFilter) {
        let level = this.maxLevel;
        if (playerCards.filter(pc => this.types.some(e=>e===pc.card.subType)).length >= this.maxNoOfCards) {
            level = -1;
        }
        this.types.forEach(t => {
            switch (t) {
                case CardSubType.Neutral:
                    filter.maxNeutralLevel = level;
                    break;
                case CardSubType.Guardian:
                    filter.maxGuardianLevel = level;
                    break;
                case CardSubType.Mystic:
                    filter.maxMysticLevel = level;
                    break;
                case CardSubType.Rouge:
                    filter.maxRougeLevel = level;
                    break;
                case CardSubType.Seeker:
                    filter.maxSeekerLevel = level;
                    break;
                case CardSubType.Survivor:
                    filter.maxSurvivorLevel = level;
                    break;
            }
        });
    }
}
export enum CardSubType {
    None,
    Weakness,
    BasicWeakness,
    Neutral,
    Guardian,
    Seeker,
    Rouge,
    Mystic,
    Survivor
}
export enum CardSlot {
    None,
    Accessory,
    Body,
    Ally,
    OneHand,
    TwoHand,
    OneArcane,
    TwoArcane
}


export class CardSet {
    //AHC01
    static theGathering = "The Gathering";
    static rats = "Rats";
    static ghouls = "Ghouls";
    static strikingFear = "Striking Fear";
    static ancientEvils = "Ancient Evils";
    static chillingCold = "Chilling Cold";
    static theMidnightMasks = "The Midnight Masks";
    static nightgaunts = "Nightgaunts";
    static darkCult = "Dark Cult";
    static lockedDoors = "Locked Doors";
    static theDevourerBelow = "The Devourer Below";
    static cultOfUmôrdhoth = "Cult of Umôrdhoth";
    static agentsOfYogSothoth = "Agents of Yog-Sothoth";
    static agentsOfShubNiggurath = "Agents of Shub-Niggurath";
    static agentsOfCthulhu = "Agents of Cthulhu";
    static agentsOfHastur = "Agents of Hastur";
    //AHC02
    static extracurricularActivity = "Extracurricular Activity";
    static theHouseAlwaysWins = "The House Always Wins";
    static sorcery = "Sorcery";
    static bishopsThralls = "Bishop's Thralls";
    static dunwich = "Dunwich";
    static wippoorwills = "Wippoorwills";
    static badLuck = "Bad Luck";
    static beastThralls = "Beast-thralls";
    static naomisCrew = "Naomi's Crew";
    static theBeyond = "The Beyond";
    static hideousAbominations = "Hideous Abominations";
    //AHC03 - The Miskatonic Museum
    static theMiskatonicMuseum = "The Miskatonic Museum";

}
export interface ICard extends ICardReference {
    pack: number;
    packNumber: number;
    name: string;
    unique: boolean;
    type: CardType;
    subType?: CardSubType;
    subType2?: string;
    set?: string;
    faceUp: boolean;
    values?: { [key: string]: any };
    tokens?: IToken[];
    exhausted?: boolean;
    victoryPoints?: number;
    flipTransformsTo?: ICard;
    xpCost?: number;
}

export interface IToken {
    token: GameToken;
    number: number;
    x?: number;
    y?: number;
    canBeMoved?: boolean;
}
export class TokenUtil {
    static getToken(card: ICard, gameToken: GameToken): IToken {
        let token: IToken;
        if (!card.tokens) card.tokens = [];
        const matchingTokens = card.tokens.filter(t => t.token === gameToken);
        if (!matchingTokens.length) {
            token = { token: gameToken, number: 0 };
            card.tokens.push(token);
        } else {
            token = matchingTokens[0];
        }
        return token;
    }
}
export enum GameToken {
    Resource = 1,
    Clue,
    Sanity,
    Health,
    Doom,
    Action
}
export class GameTokenUtil {
    static parse(name: string): GameToken {
        const eName = name[0].toUpperCase() + name.substr(1);
        const gt = GameToken[eName as keyof typeof GameToken];
        return gt;
    }
}
export interface ICardReference {
    pack: number;
    packNumber: number;
}
export class Card implements ICard {
    name: string;
    pack: number;
    type: CardType;
    set: string;
    packNumber: number;
    unique: boolean;
    faceUp: boolean = true;
    values: { [index: string]: any; };
    victoryPoints: number;
    subType?: CardSubType;
    subType2?: string;
    xpCost: number;
    constructor(pack: number, packNumber: number, type: CardType, subType: CardSubType, subType2: string, xpCost: number, name: string, unique: boolean, set: string, victoryPoints?: number) {
        this.pack = pack;
        this.packNumber = packNumber;
        this.type = type;
        this.subType = subType;
        this.subType2 = subType2;
        this.name = name;
        this.unique = unique;
        this.set = set;
        this.xpCost = xpCost;
        this.victoryPoints = victoryPoints;
    }
}
export class AssetCard extends Card {
    constructor(pack: number, packNumber: number, type: CardType, subType: CardSubType, subType2: string, xpCost: number, name: string, unique: boolean, set: string, slot: CardSlot) {
        super(pack, packNumber, type, subType, subType2, xpCost, name, unique, set);
        this.values = {};
        this.values["slot"] = slot;
    }
}
export class InvestigatorCard extends Card {
    constructor(pack: number, packNumber: number, type: CardType, subType: CardSubType, subType2: string, xpCost: number, name: string, unique: boolean, set: string, health: number, sanity: number, maxDeckSize: number, maxNeutralLevel: number, maxGuardianLevel: number, maxSeekerLevel: number, maxRougeLevel: number, maxMysticLevel: number, maxSurvivorLevel: number, freeCards: number[]) {
        super(pack, packNumber, type, subType, subType2, xpCost, name, unique, set);
        this.values = {};
        this.values["health"] = health;
        this.values["sanity"] = sanity;
        this.values["maxDeckSize"] = maxDeckSize;
        this.values["maxNeutralLevel"] = maxNeutralLevel;
        this.values["maxGuardianLevel"] = maxGuardianLevel;
        this.values["maxSeekerLevel"] = maxSeekerLevel;
        this.values["maxRougeLevel"] = maxRougeLevel;
        this.values["maxMysticLevel"] = maxMysticLevel;
        this.values["maxSurvivorLevel"] = maxSurvivorLevel;
        this.values["freeCards"] = freeCards.map((pn) => {
            return { pack: pack, packNumber: pn };
        });
    }
}
export class LocationCard extends Card {
    constructor(pack: number, packNumber: number, type: CardType, subType: CardSubType, subType2: string, xpCost: number, name: string, unique: boolean, set: string, clueBase: number, clueMultiplier: number, symbolFront: string, symbolBack: string, victoryPoints?: number) {
        super(pack, packNumber, type, subType, subType2, xpCost, name, unique, set, victoryPoints);
        this.values = {};
        this.values["clueBase"] = clueBase;
        this.values["clueMultiplier"] = clueMultiplier;
        this.values["symbolFront"] = symbolFront;
        this.values["symbolBack"] = symbolBack;
    }
}

export interface ICardToolbarAction {
    icon: string;
    title: string;
    minNoOfCards: number;
    action: () => void;
}


export class ApplicationException extends Error {
    constructor(message: string) {
        super(message);
    }
}

export interface IStarterDeck {
    investigator: ICardReference;
    deck: ICardReference[];
}

export interface IEventDispatcher<T> {
    addEventListener(event: string, handler: (arg: T) => void): void;
    removeEventListener(event: string, handler: (arg: T) => void): void;
    trigger(event: string, arg: T): void;
}
export class EventDispatcher<T> implements IEventDispatcher<T> {
    private eventHandlers: { [event: string]: { (arg: T): void }[] } = {};//F.U. syntax
    addEventListener(event: string, handler: (arg: T) => void): void {
        this.eventHandlers[event] = this.eventHandlers[event] || [];
        this.eventHandlers[event].push(handler);
    }
    removeEventListener(event: string, handler: (arg: T) => void): void {
        const handlers = this.eventHandlers[event];
        if (!handlers) return;
        const index = handlers.indexOf(handler);
        if (index >= 0) {
            handlers.splice(index, 1);
        }
    }
    trigger(event: string, arg: T): void {
        const handlers = this.eventHandlers[event];
        if (!handlers) return;
        for (let i = 0; i < handlers.length; i++) {
            handlers[i](arg);
        }
    }
}